(function(){
  'use strict'; // opt out of "sloppy mode" this is only applyed to this function however so will not break other code

  angular
    .module('iqxCore')
    .controller('ClientPreviousTempsCtrl', ClientPreviousTempsCtrl)
  
  function ClientPreviousTempsCtrl($scope, FormSvc, ApiSvc, sendMessageDialogSvc) {
    // setup capture variable for context of the new instance of the ClientPreviousTempsCtrl functon object
    var $ctrl = this

    // declare local variables
    var filters = {}

    // Setup interface for the Controller object
    $ctrl.addFilters = addFilters
    $ctrl.viewCandidate = viewCandidate
    $ctrl.refreshResults = search
    $ctrl.numPerPage = 10
    // tempList must be added to the angular scope because of how the formSvc works - will create a new form service which does not require a refrence to the angular scope at a later date
    $scope.tempList = []

    activate()

    ///////////

    function activate(){
      // setup default filters
      filters.surname = ""
      filters.dateFrom = moment().subtract(1,'years')
      filters.dateTo = moment()
      filters.active = 2

      search()
    }
  
    function addFilters(){
      var newFilters = {}
      newFilters = angular.copy(filters)
      // must pass refrence to $scope (the angular scope) as it is used to create a new scope for the modal
      FormSvc.modalForm($scope,'searchPreviousTempsModal',newFilters,'md',{label:'col-sm-3', data:'col-sm-7'})
      .then(function(newFilters){
        if(newFilters){
          filters = newFilters
          search()
        }
      })
    }

    function viewCandidate(candidate){
      var data = {candidate:candidate, choices:[{desc:'Close',type:'primary',code:''}]}

      ApiSvc.fetch(data, {
        fetchAPI:'callresult/NetClientPreviousEmployeeJobs?pPersonID='+candidate.CandidatePersonID,
        fetchTarget:'employments',
        dateFields:['StartDate', 'FinishDate'],
        multiRow:true
      })

      FormSvc.modalInfo($scope,'viewCandidateModal',data,'md')
    }
  
    function search(){
      var fetchString = 'callresult/NetClientEmployeeList'
      fetchString += '?pKeyName='+encodeURIComponent(filters.surname)
      fetchString += '&pFromDate='+encodeURIComponent(filters.dateFrom.format('YYYY-MM-DD'))
      fetchString += '&pToDate='+encodeURIComponent(filters.dateTo.format('YYYY-MM-DD'))
      fetchString += '&pActive='+encodeURIComponent(filters.active)
  
      FormSvc.setOptions($scope,{ // must pass in a refrence to the angular $scope, not to the controller as it uses stuff such as $broadcast which is available on $scope but not the controller
        fetchAPI: fetchString,
        fetchTarget: "tempList",
        multiRow:true,
        sliceSize:$ctrl.numPerPage,
        booleanFields:['CandidateActive'],
        dateFields:['LastTimesheetDate']
      })
      $scope.fetch()
    }
  }
})()
